import React, { useState, useRef, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import Profile from '../components/CandidateCV/Profile';
import Form2Print from '../components/CandidateCV/Form2Print';
import '../styles/CandidateCV.css';
import { Helmet } from 'react-helmet';
import { ConfigProvider, Button, message, Spin, Carousel, Dropdown, Tooltip } from 'antd';
import { LeftOutlined, RightOutlined, CloudDownloadOutlined, FileSearchOutlined, ProfileOutlined } from '@ant-design/icons';
import Template1 from '../components/CandidateTemplates/Template1';
import Template2 from '../components/CandidateTemplates/Template2';
import Template3 from '../components/CandidateTemplates/Template3';
import Template4 from '../components/CandidateTemplates/Template4';
import Template5 from '../components/CandidateTemplates/Template5';
import { API_URL, API_username, API_password } from '../utils/api';

const CandidateCV = () => {
	const navigate = useNavigate();
	const [loading, setLoading] = useState(true);

	useEffect(() => {
		getDropdownLists();		
	}, []);

	const [nationalities, setNationalities] = useState([]);
	const [citizenshipCountries, setCitizenshipCountries] = useState([]);
	const [birthPlaceCountries, setBirthPlaceCountries] = useState([]);
	const [relBirthPlaceCountries, setRelBirthPlaceCountries] = useState([]);
	const [employmentCountries, setEmploymentCountries] = useState([]);
	const [registrationAddressCountries, setRegistrationAddressCountries] = useState([]);
	const [residentialAddressCountries, setResidentialAddressCountries] = useState([]);
	const [maritalStatuses, setMaritalStatuses] = useState([]);
	const [languages, setLanguages] = useState([]);
	const [languageDegrees, setLanguageDegrees] = useState([]);
	const [docTypesEducation, setDocTypesEducation] = useState([]);
	const [educationTypes, setEducationTypes] = useState([]);
	const [educationKinds, setEducationKinds] = useState([]);
	const [employmentTypes, setEmploymentTypes] = useState([]);
	const [softwares, setSoftwares] = useState([]);
	const [softwareLevels, setSoftwareLevels] = useState([]);
	const [genders, setGenders] = useState([]);
	const [institutions, setInstitutions] = useState([]);
	const [relationshipDegrees, setRelationshipDegrees] = useState([]);
	const [documentTypes, setDocumentTypes] = useState([]);
	const [specialties, setSpecialties] = useState([]);

	const selectors = {
		nationalities: nationalities, 
		citizenshipCountries: citizenshipCountries,
		birthPlaceCountries: birthPlaceCountries, 
		relBirthPlaceCountries: relBirthPlaceCountries, 
		employmentCountries: employmentCountries,
		maritalStatuses: maritalStatuses,
		languageDegrees: languageDegrees,
		languages: languages,
		docTypesEducation: docTypesEducation,
		educationTypes: educationTypes,
		educationKinds: educationKinds,
		employmentTypes: employmentTypes,
		softwares: softwares,
		softwareLevels: softwareLevels,
		genders: genders,
		institutions: institutions,
		relationshipDegrees: relationshipDegrees,
		documentTypes: documentTypes,
		specialties: specialties,
		registrationAddressCountries: registrationAddressCountries,
		residentialAddressCountries: residentialAddressCountries
	}

	const getDropdownLists = () => {
		let apiUrl = `${API_URL}/lk?method=getdropdownlists&inbody=0`;
		let sessionId = localStorage.getItem("SessionId")
		fetch(apiUrl, {
			method: 'GET',
			headers: {
				'Content-Type': 'application/json',
				'Authorization': 'Basic ' + btoa(`${API_username}:${API_password}`),
				'sessionid': sessionId
			}
		})
		.then(response => {
			if (response.status === 200) {
				return response.json();
			} else if (response.status === 202) {
				message.error('Сервер на данный момент перегружен!');
				return "error";
			} else if (response.status === 404) {
				message.error('Сессия не найдена, попробуйте еще раз!');
				navigate('/logout');
				return "error";
			} else {
				message.error('Произошла ошибка при отправке запроса!');
				return "error";
			}
		})
		.then(data => {
			if (data === "error") {

			} else {
				let nationalitiesJSON = data.Nationalities.map(item => ({
					value: item.Name,
					label: item.Name,
					name: "Name",
					dataset: {
						parent: "Nationality",
						uid: item.UID
					}
				}));
				let citizenshipCountriesJSON = data.Countries.map(item => ({
					value: item.Name,
					label: item.Name,
					name: "Name",
					dataset: {
						parent: "Citizenship",
						uid: item.UID
					}
				}));
				let birthPlaceCountriesJSON = data.Countries.map(item => ({
					value: item.Name,
					label: item.Name,
					name: "Name",
					dataset: {
						parent: "Country",
						grandparent: "BirthPlace",
						uid: item.UID
					}
				}));
				let registrationAddressCountriesJSON = data.Countries.map(item => ({
					value: item.Name,
					label: item.Name,
					name: "Name",
					dataset: {
						parent: "Country",
						uid: item.UID
					}
				}));
				let residentialAddressCountriesJSON = data.Countries.map(item => ({
					value: item.Name,
					label: item.Name,
					name: "Name",
					dataset: {
						parent: "Country",
						uid: item.UID
					}
				}));
				let relBirthPlaceCountriesJSON = data.Countries.map(item => ({
					value: item.Name,
					label: item.Name,
					name: "Name",
					dataset: {
						parent: "BirthPlace_Country",
						uid: item.UID
					}
				}));
				let employmentCountriesJSON = data.Countries.map(item => ({
					value: item.Name,
					label: item.Name,
					name: "Name",
					dataset: {
						parent: "Country",
						uid: item.UID
					}
				}));
				let maritalStatusesJSON = data.FamilyStatus.map(item => ({
					value: item.Name,
					label: item.Name,
					name: "Name",
					dataset: {
						parent: "MaritalStatus",
						uid: item.UID
					}
				}));
				let languageDegreesJSON = data.LanguageDegrees.map(item => ({
					value: item.Name,
					label: item.Name,
					name: "Name",
					dataset: {
						parent: "LanguageDegree",
						uid: item.UID
					}
				}));
				let languagesJSON = data.Languages.map(item => ({
					value: item.Name,
					label: item.Name,
					name: "Name",
					dataset: {
						parent: "Language",
						uid: item.UID
					}
				}));
				let docTypesEducationJSON = data.DocTypesEducation.map(item => ({
					value: item.Name,
					label: item.Name,
					name: "Name",
					dataset: {
						parent: "DocTypeEducation",
						uid: item.UID
					}
				}));
				let educationTypesJSON = data.EducationTypes.map(item => ({
					value: item.Name,
					label: item.Name,
					name: "Name",
					dataset: {
						parent: "EducationType",
						uid: item.UID
					}
				}));
				let educationKindsJSON = data.EducationKinds.map(item => ({
					value: item.Name,
					label: item.Name,
					name: "Name",
					dataset: {
						parent: "EducationKind",
						uid: item.UID
					}
				}));
				let employmentTypesJSON = data.EmploymentTypes.map(item => ({
					value: item.Name,
					label: item.Name,
					name: "Name",
					dataset: {
						parent: "EmploymentType",
						uid: item.UID
					}
				}));
				let softwaresJSON = data.Softwares.map(item => ({
					value: item.Name,
					label: item.Name,
					name: "Name",
					dataset: {
						parent: "Software",
						uid: item.UID
					}
				}));
				let softwareLevelsJSON = data.SoftwareLevels.map(item => ({
					value: item.Name,
					label: item.Name,
					name: "Name",
					dataset: {
						parent: "SoftwareLevel",
						uid: item.UID
					}
				}));
				const map = new Map();
				data.Institutions.forEach(obj => {
					if (map.has(obj.Name)) {
						const existingObj = map.get(obj.Name);
						existingObj.UID = obj.UID;
					} else {
						map.set(obj.Name, obj);
					}
				});
				const uniqueObjects = Array.from(map.values());
				let institutionsJSON = uniqueObjects.map(item => ({
					value: item.Name,
					label: item.Name,
					name: "Name",
					dataset: {
						parent: "Institution",
						uid: item.UID
					}
				}));
				let gendersJSON = data.Genders.map(item => ({
					value: item.Name,
					label: item.Name,
					name: "Name",
					dataset: {
						parent: "Sex",
						uid: item.UID
					}
				}));
				let relationshipDegreesJSON = data.RelationshipDegrees.map(item => ({
					value: item.Name,
					label: item.Name,
					name: "Name",
					dataset: {
						parent: "RelationshipDegree",
						uid: item.UID
					}
				}));
				let documentTypesJSON = data.DocumentsTypes.map(item => ({
					value: item.Name,
					label: item.Name,
					name: "Name",
					dataset: {
						parent: "type",
						grandparent: "Passport",
						uid: item.UID
					}
				}));
				let specialtiesJSON = data.Specialties.map(item => ({
					value: item.Name,
					label: item.Name,
					name: "Name",
					dataset: {
						parent: "Speciality",
						uid: item.UID
					}
				}));
				setNationalities(nationalitiesJSON);
				setCitizenshipCountries(citizenshipCountriesJSON);
				setBirthPlaceCountries(birthPlaceCountriesJSON);
				setRelBirthPlaceCountries(relBirthPlaceCountriesJSON);
				setEmploymentCountries(employmentCountriesJSON);
				setMaritalStatuses(maritalStatusesJSON);
				setLanguages(languagesJSON);
				setLanguageDegrees(languageDegreesJSON);
				setDocTypesEducation(docTypesEducationJSON);
				setEducationTypes(educationTypesJSON);
				setEducationKinds(educationKindsJSON);
				setEmploymentTypes(employmentTypesJSON);
				setSoftwares(softwaresJSON);
				setSoftwareLevels(softwareLevelsJSON);
				setGenders(gendersJSON);
				setInstitutions(institutionsJSON);
				setRelationshipDegrees(relationshipDegreesJSON);
				setDocumentTypes(documentTypesJSON);
				setSpecialties(specialtiesJSON);
				setRegistrationAddressCountries(registrationAddressCountriesJSON);
				setResidentialAddressCountries(residentialAddressCountriesJSON);				
			}
		})
		.catch(error => {
			message.error('Ошибка: ' + error.message);
		}).finally(() => {
			setLoading(false);
		})
	};

	
	
	const [formData, setFormData] = useState({
		Name: '',
		AllowedEdit: true,
		BirthDate: '',
		BirthPlace: {
			SpecialBirthPlace: 0,
			City: "",
			District: "",
			Region: "",
			Country: {
				Name: "",
				UID: ""
			}
		},
		Nationality: {
			Name: "",
			UID: ""
		},
		Citizenship: {
			Name: "",
			UID: ""
		},
		Passport: {
			type: '',
			DocSeries: '',
			DocNumber: '',
			DocIssued: '',
			DocDateIssued: '',
			departmentCode: '',
			DocValid: '',
			DocInfoValid: ''			
		},
		MaritalStatus: '',
		EmailWork: '',
		EmailPersonal: '',
		INN: '',
		INPS: '',
		Sex: '',
		Photo: null,
		MobilePhoneWork: {
			countryCode: '',
			areaCode: '',
			number: '',
			extNumber: '',
			value: '',
			comment: ''
		},
		HomePhoneNumber: {
			countryCode: '',
			areaCode: '',
			number: '',
			extNumber: '',
			value: '',
			comment: ''
		},
		MobilePhonePersonal: {
			countryCode: '',
			areaCode: '',
			number: '',
			extNumber: '',
			value: '',
			comment: ''
		},
		WorkPhoneNumber: {
			countryCode: '',
			areaCode: '',
			number: '',
			extNumber: '',
			value: '',
			comment: ''
		},
	});

	const [educationData, setEducationData] = useState([
		{
			Start: '',
			End: '',
			EducationType: {
				Name: '',
				UID: ''
			},
			EducationKind: {
				Name: '',
				UID: ''
			},
			Institution: {
				Name: '',
				UID: ''
			},
			Faculty: '',
			Speciality: {
				Name: '',
				UID: ''
			},
			DocTypeEducation: {
				Name: '',
				UID: ''
			},
			DocSeries: '',
			DocNumber: '',
			DocDateIssued: ''
		}
	]);

	const [languageData, setLanguageData] = useState([
		{
			Language: {
				Name: '',
				UID: ''
			},
			LanguageDegree: {
				Name: '',
				UID: ''
			}
		}
	]);

	const [computerSkillsData, setComputerSkillsData] = useState([
		{
			Software: {
                Name: '',
                UID: ''
            },
            SoftwareLevel: {
                Name: '',
                UID: ''
            }
		}
	]);

	const [coursesData, setCoursesData] = useState([
		{
			Name: "",
			StartDate: "",
			EndDate: ""
		}
	])

	const [employmentData, setEmploymentData] = useState([
		{
			EmploymentDate: '',
			DismissalDate: '',
			Organization: '',
			Departament: '',
			Position: '',
			Address: '',
			Duties: '',
			ActivityProfile: '',
			Country: {
				Name: '',
				UID: ''
			},
			City: '',
			EmploymentType: {
						Name: '',
						UID: ''
					}
		}
	]);

	const [relativesData, setRelativesData] = useState([]);

	const [RegistrationAddress, setRegistrationAddress] = useState({
		AddressType: "",
		Country: {
			Name: "",
			UID: ""
		},
		City: {
			Subject: "",
			Area: "",
			MunicipalDistrict: "",
			City: "",
			Village: "",
			IntracityDistrict: "",
			PopulationPoint: "",
			Territory: "",
		},
		Street: "",
		HouseType: "",
		TypeBuilding: "",
		TypePremises: "",
		House: "",
		Building: "",
		Premises: "",
		Index: "",
		ViewAddresses: ""
	});

	const [ResidenceAddress, setResidentialAddress] = useState({
		AddressType: "",
		Country: {
			Name: "",
			UID: ""
		},
		City: {
			Subject: "",
			Area: "",
			MunicipalDistrict: "",
			City: "",
			Village: "",
			IntracityDistrict: "",
			PopulationPoint: "",
			Territory: "",
		},
		Street: "",
		HouseType: "",
		TypeBuilding: "",
		TypePremises: "",
		House: "",
		Building: "",
		Premises: "",
		Index: "",
		ViewAddresses: ""
	});
	const [ShiftMode, setShiftWorkReady] = useState(true);
	const [Prosecution, setLegalIssues] = useState(false);

	const processFormData = (data, formData) => {
		for (const key in data) {
			if (formData.hasOwnProperty(key)) {
				// Если значение является объектом, вызываем processFormData рекурсивно
				if (typeof data[key] === 'object' && data[key] !== null) {
					formData[key] = processFormData(data[key], formData[key] || {});
				} else {
					formData[key] = data[key];
				}
			}
		}
		return formData;
	};

	const handleDownloadClick = (FileExtension) => {
		// generateDocument();

		formData.Education = educationData;
		formData.Languages = languageData;
		formData.ComputerSkills = computerSkillsData;
		formData.LaborActivity = employmentData;
		formData.Family = relativesData;
		formData.Prosecution = Prosecution;
		formData.ShiftMode = ShiftMode;
		formData.RegistrationAddress = RegistrationAddress;
		formData.ResidenceAddress = ResidenceAddress;
		formData.MaketName = `EmployeeForm${slideIndex}`;
		formData.ThisEmployee = false;
		formData.FileExtension = FileExtension;
		formData.Courses = coursesData;
		setLoading(true);
        let apiUrl = `${API_URL}/lk?method=getmaketbyname&inbody=1`;
		fetch(apiUrl, {
			method: 'POST',
			headers: {
				'Content-Type': 'application/json',
				'Authorization': 'Basic ' + btoa(`${API_username}:${API_password}`)
			}, 
			body: JSON.stringify(formData)
		})
		.then(response => {
			if (response.status === 200) {
				return response.json();
			} else if (response.status === 202) {
				message.error('Сервер на данный момент перегружен!');
				return "error";
			} else if (response.status === 404) {
				message.error('Сессия не найдена, авторизуйтесь заново!');
				navigate('/logout');
				return "error";
			} else {
				message.error('Произошла ошибка при отправке запроса!');
				return "error";
			}
		})
		.then(data => {
			if (data === "error") {

			} else {
				if(FileExtension === 'PDF') {
					const base64String = data.ResumeFile; // Получаем Base64 строку из ответа
					const binaryData = atob(base64String); // Преобразуем Base64 строку в бинарные данные
					const arrayBuffer = new ArrayBuffer(binaryData.length);
					const uint8Array = new Uint8Array(arrayBuffer);
	
					for (let i = 0; i < binaryData.length; i++) {
						uint8Array[i] = binaryData.charCodeAt(i);
					}
	
					const blob = new Blob([uint8Array], { type: 'application/pdf' }); // Создаем объект Blob
					const url = window.URL.createObjectURL(blob); // Создаем URL для Blob
					const a = document.createElement('a'); // Создаем элемент ссылки
					a.href = url;
					a.download = `CV_${formData.Name.replace(/ /g, '_')}.pdf`; // Указываем имя файла для скачивания
					a.click(); 					
				} else if(FileExtension === 'DOCX') {
					const base64String = data.ResumeFile;
					const binaryData = atob(base64String);
					const arrayBuffer = new ArrayBuffer(binaryData.length);
					const uint8Array = new Uint8Array(arrayBuffer);

					for (let i = 0; i < binaryData.length; i++) {
						uint8Array[i] = binaryData.charCodeAt(i);
					}

					const blob = new Blob([uint8Array], { type: 'application/vnd.openxmlformats-officedocument.wordprocessingml.document' });
					const url = window.URL.createObjectURL(blob);
					const a = document.createElement('a');
					a.href = url;
					a.download = `CV_${formData.Name.replace(/ /g, '_')}.docx`;
					a.click();
				}
			}
		})
		.catch(error => {
			console.log(error.message)
			message.error('Ошибка: ' + error.message);
		}).finally(() => {
			setLoading(false);
		});
    }

	const [slideIndex, setSlideIndex] = useState(1);
    let sliderRef = useRef();
	const next = () => {
        sliderRef.next();
        if(slideIndex < 5) setSlideIndex(slideIndex+1);
    };
    const previous = () => {
        sliderRef.prev();
        if(slideIndex > 1) setSlideIndex(slideIndex-1);
    };

	const updateWidth = (index) => {
		const leftElement = document.querySelector('.cv-content-form-left');
		const rightElement = document.querySelector('.cv-content-form-right');

		if (leftElement && rightElement) {
		if (index === 1) {
			// leftElement.style.left = '-100%';
			leftElement.style.display = 'none';
			rightElement.style.display = 'block';
		} else if (index === 2) {
			// leftElement.style.left = '0';
			leftElement.style.display = 'block';
			rightElement.style.display = 'none';
		}
		}
	};

	const items = [
		{
		  key: '1',
		  label: (
			<p style={{ display: 'block' }} onClick={() => handleDownloadClick('DOCX')}>
			  DOCX
			</p>
		  ),
		},
		{
		  key: '2',
		  label: (
			<p style={{ display: 'block' }} onClick={() => handleDownloadClick('PDF')}>
			  PDF
			</p>
		  ),
		}
	  ];


	return (
		<ConfigProvider
			theme={{
				components: {
					Select: {
						optionFontSize: '12px'
					}
				},
			}}
		>	
		<Helmet>
			<title>Резюме кандидата</title>
		</Helmet>
		<div className='cv-content' style={{ padding: '0' }}> 
			{loading && (<div className='loader-container'>
				<Spin size="large"/>
			</div>)} 
			<Dropdown menu={{ items }} placement="top">
				<Button type='primary' style={{position: 'absolute', bottom: '32px', right: '32px', transform: 'translate(0, -50%)', zIndex: '111'}} size={'medium'} icon={<CloudDownloadOutlined /> }>Скачать резюме</Button>
			</Dropdown>
			<div className={'cv-content-form cv-content-form-left'}>
				<Profile
					formData={formData}
					setFormData={setFormData}
					educationData={educationData}
					setEducationData={setEducationData}
					languageData={languageData}
					setLanguageData={setLanguageData}
					computerSkillsData={computerSkillsData}
					setComputerSkillsData={setComputerSkillsData}
					coursesData={coursesData}
					setCoursesData={setCoursesData}
					employmentData={employmentData}
					setEmploymentData={setEmploymentData}
					relativesData={relativesData}
					setRelativesData={setRelativesData}
					RegistrationAddress={RegistrationAddress}
					setRegistrationAddress={setRegistrationAddress}
					ResidenceAddress={ResidenceAddress}
					setResidentialAddress={setResidentialAddress}
					ShiftMode={ShiftMode}
					setShiftWorkReady={setShiftWorkReady}
					Prosecution={Prosecution}
					setLegalIssues={setLegalIssues}
					selectors={selectors}
				/>
				<Tooltip placement="left" title={'Предварительный просмотр'}><Button icon={<FileSearchOutlined />} className='slide-cv-content-form-button' onClick={() => updateWidth(1)} /></Tooltip>
			</div>              
			<div className={'cv-content-form cv-content-form-right'} style={{ position: 'relative' }}>
				<Tooltip placement="right" title={'Заполнить резюме'}><Button icon={<ProfileOutlined />} className='slide-cv-content-form-button' style={{left: '0'}} onClick={() => updateWidth(2)} /></Tooltip>
				<div className='carousel-overlay'>
					<h1 className='center'>Выберите шаблон резюме {slideIndex}/5</h1>
					<button className='carousel-left-controller' onClick={previous}><LeftOutlined /></button>
					<button className='carousel-right-controller' onClick={next}><RightOutlined /></button>
				</div>					
				<Carousel ref={slider => {sliderRef = slider;}} infinite={false} dots={false} >
					<div className='carousel-item'>
						<Template1
							formData={formData}
							educationData={educationData}
							languageData={languageData}
							computerSkillsData={computerSkillsData}
							employmentData={employmentData}
							relativesData={relativesData}
							shiftWorkReady={ShiftMode}
							legalIssues={Prosecution}
							coursesData={coursesData}
							registrationAddress={RegistrationAddress}
						/>
					</div>
					<div className='carousel-item'>
						<Template2
							formData={formData}
							educationData={educationData}
							languageData={languageData}
							computerSkillsData={computerSkillsData}
							employmentData={employmentData}
							registrationAddress={RegistrationAddress}
						/>
					</div>
					<div className='carousel-item'>
						<Template3
							formData={formData}
							educationData={educationData}
							languageData={languageData}
							computerSkillsData={computerSkillsData}
							employmentData={employmentData}
							registrationAddress={RegistrationAddress}
						/>
					</div>
					<div className='carousel-item'>
						<Template4
							formData={formData}
							educationData={educationData}
							languageData={languageData}
							computerSkillsData={computerSkillsData}
							employmentData={employmentData}
							registrationAddress={RegistrationAddress}
						/>
					</div>
					<div className='carousel-item'>
						<Template5
							formData={formData}
							educationData={educationData}
							languageData={languageData}
							computerSkillsData={computerSkillsData}
							employmentData={employmentData}
							registrationAddress={RegistrationAddress}
						/>
					</div>
					{/* <div className='carousel-item'>
						<Form2Print 
							formData={formData}
							educationData={educationData}
							languageData={languageData}
							computerSkillsData={computerSkillsData}
							employmentData={employmentData}
							relativesData={relativesData}
							RegistrationAddress={RegistrationAddress}
							ResidenceAddress={ResidenceAddress}
							ShiftMode={ShiftMode}
							Prosecution={Prosecution}
						/>
					</div> */}
				</Carousel>                    
			</div>            
		</div>
		</ConfigProvider>
	);
};

export default CandidateCV;
